import React from 'react';
import PropTypes from 'prop-types';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from 'reactstrap';
import css from 'styled-jsx/css';

const { className, styles } = css.resolve`
  div {
    min-width: unset;
  }
`;

const STATUS_OPTIONS = [
  { display: 'Active', status: 'positive' },
  { display: 'Inactive', status: 'negative' },
  { display: 'All', status: 'all' },
];
const DISPLAY_MAP = new Map([
  ['positive', 'Active'],
  ['negative', 'Inactive'],
  ['all', 'All'],
]);

export default function StatusSelectDropdown({
  selectedStatus,
  handleStatusSelected,
  mobileView,
}) {
  return (
    <UncontrolledDropdown className={mobileView ? 'border rounded' : ''}>
      <DropdownToggle
        caret
        className={`text-decoration-none text-text-light-gray d-flex align-items-center justify-content-between ${
          mobileView ? 'p-1 w-100' : 'p-0'
        }`}
        color="link"
      >
        <span className="text-capitalize three-quarter-text">
          {DISPLAY_MAP.get(selectedStatus)}
        </span>
      </DropdownToggle>
      <DropdownMenu
        className={`${className} rounded-lg ${mobileView ? 'w-100' : ''}`}
      >
        {STATUS_OPTIONS.map(({ status, display }) => (
          <DropdownItem
            className="three-quarter-text px-3"
            key={status}
            onClick={() => handleStatusSelected(status, mobileView)}
          >
            {display}
          </DropdownItem>
        ))}
        {styles}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
}

StatusSelectDropdown.propTypes = {
  selectedStatus: PropTypes.oneOf(STATUS_OPTIONS.map(({ status }) => status)),
  handleStatusSelected: PropTypes.func,
  mobileView: PropTypes.bool,
};
